import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { AppModal, AppRemixIcon } from '@/layout/AppComponents';
import { ProgressBar } from 'react-bootstrap';
import axios from 'axios';
import * as currentPageAction from '../../../../../store/actions/currentPageAction';
import AuxSidebar from '../../../../Sidebar/AuxSidebar';
import { axiosPath, path } from '../../../../../routing/helpers/router';
import Translator from '../../../../components/helpers/Translator';
import colors from '../../../../../constants/colors';
import useIsMounted from '../../../../components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';

const ReportSidebarBlock = () => {
  const isMounted = useIsMounted();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { moduleBridgeHex, view, filtersHex } = useParams();
  const auxSidebar = useSelector(
    (state) => state.currentPage?.auxSidebar?.opened
  );
  const [openOnce, setOpenOnce] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [reportUrl, setReportUrl] = useState(null);
  const [isError, setIsError] = useState(false);

  const handleAuxSidebar = () => {
    if (!openOnce) {
      setOpenOnce(true);
    }
    if (auxSidebar !== 'reports') {
      dispatch(currentPageAction.change('auxSidebar', { opened: 'reports' }));
    } else {
      dispatch(currentPageAction.change('auxSidebar', { opened: null }));
    }
  };

  const removeFilters = useCallback(
    () =>
      navigate(
        path({
          name: 'user_module_correctiveActions_task_list',
          params: {
            moduleBridgeHex,
            view,
            page: 1,
            filtersHex: 0,
          },
        })
      ),
    [moduleBridgeHex]
  );

  // > LOAD REPORT
  const loadReportTaskXls = useCallback(() => {
    setShowModal(true);
    axios
      .post(axiosPath('api_r_user_module_correctiveActions_report_task_xls'), {
        moduleBridgeHex,
        filtersHex,
        view,
      })
      .then((r) => {
        if (isMounted) {
          setReportUrl(r.data.reportUrl);
        }
      })
      .catch((e) => {
        setIsError(true);
        dispatch(errorHandler(e));
      });
  }, [moduleBridgeHex, view, filtersHex]);
  // < LOAD REPORT

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
    setReportUrl(null);
    setIsError(false);
  }, []);

  return (
    <>
      <li
        className={auxSidebar && auxSidebar === 'reports' ? 'active' : ''}
        onClick={handleAuxSidebar}
      >
        <span className="sidebar-element">
          <AppRemixIcon icon="file-chart" className="sidebar-icon" />{' '}
          <span className="sb-title">
            <Translator file="user" name="user.export.gcl" />
          </span>
        </span>
      </li>
      <AuxSidebar
        title={<Translator file="user" name="user.export.gcl" />}
        isOpen={auxSidebar && auxSidebar === 'reports'}
        width="350px"
        position="left"
        onClose={handleAuxSidebar}
      >
        {openOnce && (
          <>
            {filtersHex != 0 && (
              <div
                className="alert alert-danger alert-dismissible fade show"
                role="alert"
              >
                <Translator
                  file="module-legalCompliance"
                  name="module.lc.export-filtered.selected-filters"
                />
                <button type="button" className="close" onClick={removeFilters}>
                  <AppRemixIcon icon="delete-bin-6" size={16} />
                </button>
              </div>
            )}
            <div
              className="d-flex pointer mb-2"
              onClick={() => loadReportTaskXls()}
            >
              <AppRemixIcon
                icon="file-excel"
                className="mr-1"
                color={colors.success}
                filled
              />
              <Translator
                file="module-correctiveActions"
                name="module.ca.tasks"
              />
            </div>
          </>
        )}
      </AuxSidebar>
      <AppModal
        show={showModal}
        title={
          <Translator file="module-legalCompliance" name="export.report" />
        }
        onClose={handleCloseModal}
        isCloseButton={reportUrl || isError}
      >
        {reportUrl ? (
          <div className="text-center">
            <a className="btn btn-sm btn-primary" href={reportUrl}>
              <Translator
                file="module-legalCompliance"
                name="download.report"
              />
            </a>
          </div>
        ) : isError ? (
          <div className="text-danger">
            <Translator
              file="module-legalCompliance"
              name="error.contact.admin"
            />
          </div>
        ) : (
          showModal && (
            <>
              <div>
                <Translator file="module-legalCompliance" name="downloading" />
                ...
              </div>
              <ProgressBar animated now={100} />
            </>
          )
        )}
      </AppModal>
    </>
  );
};
export default ReportSidebarBlock;
